import { STATSIG_EXPERIMENTS, statsigExperimentManager } from '@src/experiments/statsig-integration'

import Product from '../../domains/Product'

import { EDDRequestProducts } from './eddService.types'

export const generateEDDProductPayload = (product: Product[]): EDDRequestProducts => {
  return product.reduce<EDDRequestProducts>((acc, curr) => {
    return [
      ...acc,
      {
        product_id: curr.id.toString(),
        variant_ids: curr.variants?.map(variant => variant.id.toString()),
      },
    ]
  }, [])
}

export const appendEDDExpBucketToHeaders = () => {
  const exposedExperiments = statsigExperimentManager.getExposedBuckets()
  const eddExpBucket = exposedExperiments.find(experiment => experiment.experimentName === STATSIG_EXPERIMENTS.EDD)
  if (eddExpBucket) {
    return {
      'X-Buckets': JSON.stringify({
        [STATSIG_EXPERIMENTS.EDD]: eddExpBucket.bucketName,
      }),
    }
  }
  return {}
}
